<template>
  <div class="main">
    <van-nav-bar title="投票详情" left-arrow @click-left="onClickLeft" />
    <van-pull-refresh v-model="loading" @refresh="onRefresh">
      <div class="container">
        <div class="top">
          <div class="left">
            <p class="title">{{ currentData.tpmc || "" }}</p>
            <div class="btn">
              <div class="voteBottom">
                <div class="voteIn">
                  <img src="../../assets/img/ico_renshu.png" alt="" />
                  <span>参与:{{ currentData.tprs || 0 }}人</span>
                </div>
                <div class="VoteType">
                  {{ currentData.tplx == 1 ? "使用投票" : "验收投票" }}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="content">
          <!-- <div class="right"> -->
          <div class="images">
            <img
              class="images"
              width="77px"
              height="88px"
              src="../../assets/img/img_toupiao.png"
            />
          </div>
          <!-- </div> -->
          <p class="vote-time">投票时间:</p>
          <div class="voteName">
            <img
              style="vertical-align: middle"
              src="../../assets/img/ico_time_begin.png"
              alt=""
            />
            <div class="name" style="vertical-align: middle; line-height: 21px">
              {{ currentData.tpkssj }}
            </div>
            <img
              style="vertical-align: middle"
              src="../../assets/img/ico_time_over.png"
              alt=""
            />
            <div class="name" style="vertical-align: middle; line-height: 21px">
              {{ currentData.tpjssj }}
            </div>
          </div>

          <p class="vote-time">投票详情：</p>
          <p class="text">
            {{ currentData.tpms }}
          </p>
          <div class="example">
            <img
              v-for="(item, index) in oneList"
              :key="index"
              class="one"
              :src="item.url"
              alt=""
            />
          </div>
          <div class="example" style="margin-top: 10px">
            <img
              v-for="(item, index) in twoList"
              :key="index"
              class="one"
              :src="item.url"
              alt=""
            />
          </div>
          <p class="vote-time">业主签名：</p>
          <img style="width: 100%" :src="currentData.qmUrl" alt="" />
        </div>
        <div class="footer">
          <p class="vote-time">投票详情：</p>

          <div v-if="currentData.status == 0">
            <div
              v-for="(item, index) in options"
              :key="index"
              @click="getVote(index)"
            >
              <div class="voteunselect" :class="{ active: active == index }">
                {{ item.lable }}
              </div>
            </div>
            <van-button :loading="sumitLoad" class="save" @click="handlerSave">
              确认</van-button
            >
          </div>

          <div v-else>
            <!-- 同意 -->
            <div class="argument">
              <p class="argument-title">
                同意<span style="color: #ff6c19" v-if="currentData.tpqk == 1"
                  >(我的选择)</span
                >
              </p>
              <p class="argument-renshu">
                {{ `${currentData.tptyrs}人(${currentData.tyrszb}%)` }}
              </p>
            </div>
            <van-progress
              :color="currentData.tpqk == 1 ? '#f2826a' : '#1989fa'"
              :percentage="currentData.tyrszb"
              :show-pivot="false"
            />

            <!-- 反对 -->
            <div class="argument">
              <p class="argument-title">
                反对<span style="color: #ff6c19" v-if="currentData.tpqk == 2"
                  >(我的选择)</span
                >
              </p>
              <p class="argument-renshu">
                {{ `${currentData.tpfdrs}人(${currentData.fdrszb}%)` }}
              </p>
            </div>
            <van-progress
              :color="currentData.tpqk == 2 ? '#f2826a' : '#1989fa'"
              :percentage="currentData.fdrszb"
              :show-pivot="false"
            />
            <!-- <div class="progress">
            <div class="against-son"></div>
          </div> -->
            <!-- 放弃 -->
            <div class="argument">
              <p class="argument-title">
                弃权<span style="color: #ff6c19" v-if="currentData.tpqk == 3"
                  >(我的选择)</span
                >
              </p>
              <p class="argument-renshu">
                {{ `${currentData.qprs}人(${currentData.qprszb}%)` }}
              </p>
            </div>
            <van-progress
              :color="currentData.tpqk == 3 ? '#f2826a' : '#1989fa'"
              :percentage="currentData.qprszb"
              :show-pivot="false"
            />

            <van-button class="show-btn" disabled>已投票</van-button>
          </div>
        </div>
      </div>
    </van-pull-refresh>

    <van-popover placement="top" />

    <!-- <van-dialog v-model="signShow" width="100vm" height="160px" :before-close="beforeClose" show-cancel-button> -->
    <van-popup v-model="signShow" position="bottom" round style="height: 550px">
      <div style="font-size: 20px; font-weight: 600; margin: 20px">
        签字确认
      </div>

      <signFont ref="sign" @success="getUrl" @close="cancel"></signFont>
    </van-popup>
  </div>
</template>
<script>
import api from "@/api/vote.js";
import signFont from "./singFont.vue";
export default {
  name: "",
  components: {
    signFont,
  },
  data() {
    return {
      show: true,
      qmUrl: "",
      qmName: "",
      loading: false,
      signShow: false,
      status: "0", // 1已投票  0 未投票
      options: [
        {
          lable: "同意",
          value: "1",
        },
        {
          lable: "反对",
          value: "2",
        },
        {
          lable: "弃权",
          value: "3",
        },
      ],
      currentData: {
        status: 0,
      },
      oneList: [],
      twoList: [],
      active: null,
      activeColor: "",
      fwId: "",
      sumitLoad: false,
    };
  },
  created() {
    // this.fwId = sessionStorage.getItem("fwId");

    this.getVoteDetail();
  },
  methods: {
    /**
     * 投票详情
     */
    getVoteDetail() {
      this.loading = true;
      let params = {
        openId: sessionStorage.getItem("openId"),
        tpId: this.$route.query.id,
        fwId: this.$route.query.fwId,
      };
      api.getInfo(params).then((res) => {
        console.log("=res.data", res.data);
        if (res.data.code == 200) {
          this.currentData = {
            ...res.data.data,
          };

          // 文件替换为外网ip

          this.currentData.qmUrl = res.data.data.qmUrl.replace(
            "http://172.17.20.11:9000",
            "http://222.214.193.17:9000"
          );

          if (res.data.data.fileDto.length > 0) {
            res.data.data.fileDto.forEach((item) => {
              item.url = item.url.replace(
                "http://172.17.20.11:9000",
                "http://222.214.193.17:9000"
              );
            });
          }

          if (res.data.data.fileDto && res.data.data.fileDto.length > 3) {
            this.oneList = res.data.data.fileDto.slice(0, 3);
            this.twoList = res.data.data.fileDto.slice(
              3,
              res.data.data.fileDto.length
            );
          } else {
            this.oneList = res.data.data.fileDto;
          }
          this.loading = false;
        } else {
          this.loading = false;
          this.$toast.fail({
            message: res.data.msg,
          });
        }
      });
    },
    onRefresh() {
      this.getVoteDetail();
    },
    onClickLeft() {
      window.history.go(-1);
    },
    getVote(idx) {
      this.active = idx;
      this.signShow = true;
    },
    cancel(val1, val2) {
      this.signShow = val2;
    },
    getUrl(val) {
      this.qmUrl = val;
      let name = val.substring(val.lastIndexOf("/") + 1);
      this.qmName = name;
    },
    beforeClose(action, done) {
      // 点击事件 - 备注按钮提示框
      if (action === "confirm") {
        // 确认
        this.$refs.sign.handleGenerate();
        done();
        // 关闭提示框
      } else if (action === "cancel") {
        // 取消
        this.$refs.sign.handleReset();
        done(); // 关闭提示框
      }
    },

    /**
     * 确认投票
     */
    handlerSave() {
      if (this.active == null) {
        this.$toast.fail({
          message: "请选择你的投票意向",
        });
      } else {
        if (this.qmUrl == "") {
          this.$toast.fail({
            message: "请签名",
          });
          this.signShow = true;
        } else {
          this.sumitLoad = true;
          let tpqk_temp = this.active;
          let params = {
            openId: sessionStorage.getItem("openId"),
            tpId: this.$route.query.id,

            tpqk: ++tpqk_temp,
            tplx: this.$route.query.tplx,
            tpjssj: this.currentData.tpjssj,
            tpkssj: this.currentData.tpkssj,
            qmUrl: this.qmUrl,
            qmName: this.qmName,
            fwId: this.currentData.fwId,
          };
          api
            .cytp(params)
            .then((res) => {
              this.sumitLoad = false;
              if (res.data.code == 200) {
                this.$toast.success({
                  message: "投票成功",
                });

                this.getVoteDetail();
              } else {
                this.$toast.fail({
                  message: res.data.msg,
                });
              }
            })
            .catch((err) => {
              this.sumitLoad = false;
              this.$toast.fail({
                message: err,
              });
            });
        }
      }
    },
  },
};
</script>

<style lang="less" scoped>
.van-nav-bar {
  position: sticky;
  top: 0;
  z-index: 999;
}

.main {
  background: linear-gradient(
    180deg,
    rgba(255, 216, 193, 0.42) 0%,
    rgba(255, 216, 193, 0) 100%
  );

  .container {
    padding: 20px;

    // padding-bottom: 20px;
    .top {
      display: flex;
      width: 100%;
      min-height: 100px;
      // overflow: hidden;

      .left {
        flex: 3;
        width: 60%;

        .title {
          position: relative;
          z-index: 9;
          width: 335px;
          min-height: 30px;
          margin: 0;
          font-size: 20px;
          font-family: PingFang SC-Semibold, PingFang SC;
          font-weight: 600;
          color: #222120;
          line-height: 30px;
        }

        .btn {
          margin-top: 10px;

          .join {
            width: 120px;
            height: 30px;
            background: #f7f7f7;
            border-radius: 4px 4px 4px 4px;
            opacity: 1;
            border: 1px solid #e9e9e9;
            font-size: 13px;
          }

          .vote {
            width: 80px;
            height: 30px;
            font-size: 13px;
            border-radius: 4px 4px 4px 4px;
            opacity: 1;
            border: 1px solid #00c797;
          }
        }
      }

      // .right {
      //   flex: 1;
      //   width: 40%;
      //   margin-top: 20px;

      //   .images {
      //     width: 120px;
      //     height: 120px;
      //     background: transparent;
      //   }
      // }
    }

    .content {
      position: relative;
      width: 100%;
      min-height: 250px;
      background: #ffffff;
      padding: 16px;
      border-radius: 10px 10px 10px 10px;
      opacity: 1;

      .images {
        position: absolute;
        top: -52px;
        right: 0px;
        width: 120px;
        height: 120px;
        background: transparent;
      }

      .vote-time {
        font-size: 16px;
        font-family: PingFang SC-Semibold, PingFang SC;
        font-weight: 600;
        color: #4e4d4d;
        line-height: 19px;
      }

      .text {
        width: 100%;
        min-height: 30px;
        word-break: break-all;
        font-size: 14px;
        font-family: PingFang SC-Medium, PingFang SC;
        font-weight: 500;
        color: #4e4d4d;
        line-height: 30px;
      }

      .example {
        display: flex;

        .one {
          width: 31.5%;
          height: 96px;
          border-radius: 4px 4px 4px 4px;
          opacity: 1;
          margin-right: 10px;
        }
      }
    }

    .footer {
      width: 100%;
      height: 300px;
      background: #ffffff;
      padding: 16px;
      border-radius: 10px 10px 10px 10px;
      opacity: 1;
      margin-top: 20px;

      .voteunselect {
        position: relative;
        width: 100%;
        height: 32px;
        line-height: 32px;
        font-size: 14px;
        text-align: center;
        background: #f0f0f0;
        border-radius: 16px 16px 16px 16px;
        opacity: 1;
        margin-bottom: 20px;
      }

      .voteunselect::after {
        content: "";
        position: absolute;
        right: 9px;
        top: 8px;

        width: 14px;
        height: 14px;
        background: #ffffff;
        border-radius: 16px 16px 16px 16px;
        border: 1px solid #bababa;
      }

      .active {
        position: relative;
        width: 100%;
        height: 32px;
        font-size: 14px;
        line-height: 32px;
        text-align: center;
        color: #fff;
        background: linear-gradient(133deg, #ff6c19 0%, #ffa370 100%);
        border-radius: 16px 16px 16px 16px;
        opacity: 1;
        margin-bottom: 20px;
      }

      .active::after {
        content: "";
        position: absolute;
        top: 8px;
        right: 9px;
        width: 14px;
        height: 16px;
        background: url(../../assets/img/icon_radio_true.png) no-repeat;
        border-radius: 16px 16px 16px 16px;
        border: none;
      }

      .save {
        width: 100%;
        height: 44px;
        color: #fff;
        background: #ff6c1a;
        border-radius: 53px 53px 53px 53px;
        opacity: 1;
        margin-bottom: 20px;
      }

      .argument {
        display: flex;
        flex-direction: row;

        flex-wrap: nowrap;

        justify-content: space-between;
        width: 303px;
        height: 40px;
        opacity: 1;

        .argument-title {
          flex: 3;
          width: 112px;
          height: 20px;
          font-size: 14px;
          font-family: PingFang SC-Medium, PingFang SC;
          font-weight: 500;
          color: #4e4d4d;
          line-height: 16px;
        }

        .argument-renshu {
          height: 20px;
          font-size: 14px;
          font-family: PingFang SC-Medium, PingFang SC;
          font-weight: 500;
          color: #999998;
          line-height: 16px;
        }
      }

      .progress {
        position: relative;
        width: 303px;
        height: 13px;
        background: #f0f0f0;
        border-radius: 6px 6px 6px 6px;
        opacity: 1;

        .progress-son {
          position: absolute;
          width: 85px;
          height: 13px;
          background: linear-gradient(133deg, #ff6c19 0%, #ffa370 100%);
          border-radius: 19px 19px 19px 19px;
          opacity: 1;
        }

        .against-son {
          width: 196px;
          height: 13px;
          background: linear-gradient(270deg, #1991ff 0%, #70b2ff 100%);
          border-radius: 19px 19px 19px 19px;
          opacity: 1;
        }

        .against-abandon {
          width: 31px;
          height: 13px;
          background: linear-gradient(270deg, #1991ff 0%, #70b2ff 100%);
          border-radius: 19px 19px 19px 19px;
          opacity: 1;
        }
      }

      .show-btn {
        margin-top: 20px;
        width: 100%;
        height: 44px;
        background: #ffbb96;
        border-radius: 53px 53px 53px 53px;
        opacity: 1;
      }
    }
  }
}

// #EDEDED
.voteBottom {
  padding: 0 16px;
  margin: 20px 0;

  button {
    padding: 0 17px;
    height: 30px;
    line-height: 30px;
    text-align: center;
    background-color: #ff6c1a;
    color: #fff;
    border-radius: 30px;
    float: right;
    border: none;
    font-size: 13px;
  }

  .voteIn,
  .VoteType {
    display: inline-block;
    font-size: 13px;
    line-height: 30px;
    padding: 0 5px;
    border-radius: 3px;
  }

  .voteIn {
    background: #f7f7f7;
    color: #6b6a6a;
    border: 1px solid #e9e9e9;
    letter-spacing: 1px;

    img {
      // margin-top: 5px;
      margin-top: 6px;
      margin-right: 5px;
      float: left;
      width: 16px;
      height: 16px;
    }
  }

  .VoteType {
    color: #00c797;
    background: rgba(0, 199, 151, 0.05);
    border: 1px solid #00c797;
    margin-left: 5px;
  }
}

.voteName {
  margin-top: 16px;
  padding: 0 16px;
  display: flex;

  img {
    display: block;
    width: 22px;
    height: 22px;
  }

  .name {
    // flex: 1;
    width: 85px;
    height: 20px;
    font-size: 14px;
    font-family: PingFang SC-Medium, PingFang SC;
    font-weight: 500;
    color: #4e4d4d;
    line-height: 16px;
    margin-left: 5px;

    overflow: hidden;
    margin-right: 10px;
  }
}

.van-progress {
  // margin-top: 20px;
  height: 16px;
  border-radius: 8px 8px 8px 8px;
  background: #f0f0f0;

  border: 2px solid #ffffff;

  /deep/.van-progress__portion {
    top: -2px;
    background: linear-gradient(270deg, #1991ff 0%, #70b2ff 100%);
    border-radius: 19px 19px 19px 19px;
    height: 16px;
    border: 2px solid #ffffff;
  }
}
</style>
